import { RECIEVE_ENTITIES } from "actions/actionTypes";
import { Map, merge, fromJS } from "immutable";

const initialState = Map({});

const entityReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECIEVE_ENTITIES:
      if (action.payload) {
        return state.withMutations((s) => {
          for (const prop in action.payload) {
            const old = s.get(prop);
            if (!old) {
              s.set(prop, fromJS(action.payload[prop]));
            } else {
              s.set(prop, merge(s.get(prop), fromJS(action.payload[prop])));
            }
          }
        });
      } else {
        return state;
      }
    default:
      return state;
  }
};
export default entityReducer;
